import React from 'react'

const AdminDashboard = () => {
    console.log("component admin")
    return (
        <div>Admin Dashboard</div>
    )
}

export default AdminDashboard;